const SIZES = { sm: "87.5%", md: "100%", lg: "112.5%", xl: "125%" };
const STORAGE_KEY = "prairie_text_size";

const isValidSize = (v) => typeof v === "string" && Object.prototype.hasOwnProperty.call(SIZES, v);

export const applyTextSize = (size) => {
  const key = isValidSize(size) ? size : "md";
  const v = SIZES[key];
  if (typeof document !== "undefined") {
    document.documentElement.style.fontSize = v;
  }
  try {
    localStorage.setItem(STORAGE_KEY, key);
  } catch (e) {
    if (process.env.NODE_ENV !== "production") console.warn("[textSize] persist failed:", e);
  }
};

export const initialTextSize = () => {
  if (typeof window === "undefined") return "md";
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return isValidSize(raw) ? raw : "md";
  } catch {
    return "md";
  }
};

export const TEXT_SIZE_OPTIONS = ["sm", "md", "lg", "xl"];

// Apply on import so first paint is correct
if (typeof window !== "undefined") {
  applyTextSize(initialTextSize());
}
